import React from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getIconPath } from '@tcp/core/src/utils/';

import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles from '../styles/InformationHeader.style';
import { getDynamicLabelValues } from '../../../../../../../utils/labels/labelUtilty';

const InformationHeader = ({ className, closeAction, isShowSuccessMessageState, errorMessage }) => {
  const closeIcon = getIconPath('white-cross-icon');
  const checkIcon = getIconPath('tick-green');

  return (
    <div className={className}>
      <div className="info-container">
        <span className="text-container">
          {isShowSuccessMessageState ? (
            <Image className="check-icon" src={checkIcon} alt="close-overlay" />
          ) : (
            <span className="outer-cont">!</span>
          )}

          {isShowSuccessMessageState ? (
            <BodyCopy
              component="div"
              fontFamily="secondary"
              fontWeight="semibold"
              fontSize={['fs12', 'fs14']}
              color="white"
            >
              {getDynamicLabelValues('dynamic.account_d.lbl_addpickup_success_message')}
            </BodyCopy>
          ) : (
            <BodyCopy
              component="div"
              fontFamily="secondary"
              fontWeight="semibold"
              fontSize={['fs12', 'fs14']}
              color="white"
            >
              {errorMessage}
            </BodyCopy>
          )}
        </span>
        <Image
          onClick={() => {
            closeAction(false);
          }}
          className="close-icon"
          src={closeIcon}
          alt="close-overlay"
        />
      </div>
    </div>
  );
};

export default withStyles(InformationHeader, styles);
export { InformationHeader as InformationHeaderVanilla };
